import angular from 'angular';

import Component from './event-manage.component';

const Module = angular.module('control-room.events.components.event-manage', []).component('crEventManage', Component);

export default Module;
